export const LEADERBOARD_SCOPE_SLIDE = 'slide'
export const LEADERBOARD_SCOPE_SINCE_LAST = 'since_last'

export const getLeaderboardScope = (leaderboardSlide) => {
  const scope = leaderboardSlide?.metadata?.leaderboardScope
  return scope === LEADERBOARD_SCOPE_SLIDE || scope === LEADERBOARD_SCOPE_SINCE_LAST ? scope : null
}

const byOrder = (a, b) => a.order - b.order

/**
 * Narrows the slides a leaderboard ranks by. Returns the whole-quiz input untouched when
 * the slide has no narrow scope. The leaderboard's own id stays in the narrowed list so
 * manual points awarded while it is on screen still count.
 */
export const resolveLeaderboardRange = ({
  slides,
  leaderboardSlide,
  isScoredSlide,
  wholeQuizSlideIds,
  wholeQuizLastSlideId,
}) => {
  const scope = getLeaderboardScope(leaderboardSlide)
  if (!scope) return { slideIds: wholeQuizSlideIds, lastSlideId: wholeQuizLastSlideId }

  const scoredBefore = (slides || [])
    .filter((slide) => isScoredSlide(slide) && slide.order < leaderboardSlide.order)
    .sort(byOrder)

  let rankedSlides
  if (scope === LEADERBOARD_SCOPE_SLIDE) {
    rankedSlides = scoredBefore.slice(-1)
  } else {
    const previousLeaderboardOrder = (slides || [])
      .filter((slide) => slide.type === 'leaderboard' && slide.order < leaderboardSlide.order)
      .reduce((latest, slide) => Math.max(latest, slide.order), -Infinity)
    rankedSlides = scoredBefore.filter((slide) => slide.order > previousLeaderboardOrder)
  }

  return {
    slideIds: [...rankedSlides.map((slide) => Number(slide.id)), Number(leaderboardSlide.id)],
    lastSlideId: undefined,
  }
}
